import { BuilderComponentProps } from "../BuilderInterface";
import "./style.scss";
import classNames from "classnames";
import {
    getColorsFromInteractiveStates,
    getCompoundStyle,
    getStateStyleForBuilder,
    getStylesFromInteractiveStates
} from "../helpers";

import { IconNode, NodeStates } from "../../build/types";
import DynamicIcon from "../DynamicIcon";
import { useInteractionStates } from "../../hooks/useInteractionStates";

const BuilderIcon: React.FC<BuilderComponentProps> = ({
    node,
    actionCallbacks,
    builderProps,
    disabled
}: BuilderComponentProps) => {
    const iNode = node as IconNode;
    const { id, attr, stateManager, icon } = iNode;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    const iconClasses = classNames("builder-icon", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { nodeState, selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        return (
            <div
                {...attr}
                className={iconClasses}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                {icon?.src && (
                    <DynamicIcon
                        name={icon.src}
                        colors={icon.colors}
                        style={getCompoundStyle({
                            otherStyle: icon?.style,
                            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "icon_style")
                        })}
                    />
                )}
            </div>
        );
    } else {
        const iconWrapperStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        const iconStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: icon?.style,
            stateManager,
            paths: ["icon_style"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        const iconColors = getColorsFromInteractiveStates({
            states,
            stateManager,
            paths: ["icon_colors"],
            defaultColors: icon?.colors,
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <div {...attr} {...actionCallbacks} className={iconClasses} style={iconWrapperStyle} ref={setElement}>
                {icon?.src && <DynamicIcon name={icon.src} style={iconStyle} colors={iconColors} />}
            </div>
        );
    }
};

export default BuilderIcon;
